import React, {FC} from 'react';
// components
// import {NavigationBar} from 'src/components/toolbars';
import bondLogin from '../image/login-bg.jpg';

export interface IBasicLayoutProps {
  children: React.ReactNode;
}

const BasicLayout: FC<IBasicLayoutProps> = ({children}) => {
  return (
    <div className='bondLogin' style={{background: `url(${bondLogin})`}}>
      {/* <NavigationBar /> */}
      <main>{children}</main>
    </div>
  );
};

export default BasicLayout;
